import { render, staticRenderFns } from "./BookAutocomplete.vue?vue&type=template&id=242a75f8&"
import script from "./BookAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BookAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports